(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.SwissKopperColorMix) return;

  const selector = '[data-swiss-color-card]';
  const configurations = new WeakMap();
  const listStates = new WeakMap();
  const manualSelections = new WeakMap();
  const previousColors = new Map();
  const currentColors = new Map();
  let scheduled = false;

  function colorKey(value) {
    return String(value).normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  }

  function configuration(card) {
    if (!configurations.has(card)) {
      try {
        configurations.set(card, JSON.parse(card.getAttribute('data-swiss-color-data')));
      } catch (error) {
        configurations.set(card, null);
      }
    }
    return configurations.get(card);
  }

  function storageKey(productId) {
    return 'swisskopper-color-v2:' + location.pathname + ':' + productId;
  }

  function previousColor(productId) {
    if (!previousColors.has(productId)) {
      let value = null;
      try { value = sessionStorage.getItem(storageKey(productId)); } catch (error) {}
      previousColors.set(productId, value);
    }
    return previousColors.get(productId);
  }

  function remember(productId, color) {
    previousColor(productId);
    currentColors.set(productId, colorKey(color));
    try { sessionStorage.setItem(storageKey(productId), colorKey(color)); } catch (error) {}
  }

  function allocate(cards, history) {
    const entries = cards.map((card, position) => {
      const config = configuration(card);
      const manual = manualSelections.get(card);
      const variants = manual ? [manual] : (config?.variants || []).filter(variant => variant.available && variant.image);
      return {card, config, variants, position};
    }).filter(entry => entry.variants.length);
    const colors = [...new Set(entries.flatMap(entry => entry.variants.map(variant => colorKey(variant.color))))];
    const source = 0;
    const colorStart = 1 + entries.length;
    const sink = colorStart + colors.length;
    const graph = Array.from({length: sink + 1}, () => []);

    function edge(from, to, capacity, cost, variant = null) {
      const forward = {to, reverse: graph[to].length, capacity, cost, variant};
      const backward = {to: from, reverse: graph[from].length, capacity: 0, cost: -cost};
      graph[from].push(forward);
      graph[to].push(backward);
    }

    entries.forEach((entry, index) => {
      edge(source, index + 1, 1, 0);
      const previous = previousColor(entry.config.productId);
      const current = currentColors.get(entry.config.productId);
      const recent = history.slice(Math.max(0, history.length - 5 + entry.position));
      entry.variants.forEach(variant => {
        const key = colorKey(variant.color);
        const cost = (key === previous ? 10000 : 0) + (current && key !== current ? 1000 : 0) + (recent.includes(key) ? 500 : 0) + Math.floor(Math.random() * 100);
        edge(index + 1, colorStart + colors.indexOf(key), 1, cost, variant);
      });
    });

    colors.forEach((color, index) => {
      for (let count = 0; count < entries.length; count++) {
        edge(colorStart + index, sink, 1, count === 0 ? 0 : 1000000 + count * 100);
      }
    });

    for (let flow = 0; flow < entries.length; flow++) {
      const distance = Array(graph.length).fill(Infinity);
      const path = Array(graph.length);
      distance[source] = 0;
      for (let pass = 0; pass < graph.length - 1; pass++) {
        let changed = false;
        graph.forEach((edges, from) => {
          edges.forEach((item, index) => {
            if (item.capacity > 0 && distance[from] + item.cost < distance[item.to]) {
              distance[item.to] = distance[from] + item.cost;
              path[item.to] = [from, index];
              changed = true;
            }
          });
        });
        if (!changed) break;
      }
      if (!Number.isFinite(distance[sink])) break;
      for (let node = sink; node !== source;) {
        const [from, index] = path[node];
        const item = graph[from][index];
        item.capacity--;
        graph[node][item.reverse].capacity++;
        node = from;
      }
    }

    return entries.map((entry, index) => ({
      card: entry.card,
      variant: graph[index + 1].find(item => item.variant && item.capacity === 0)?.variant
    })).filter(selection => selection.variant);
  }

  function updateImage(oldImage, details, alternate) {
    if (oldImage && oldImage.getAttribute('data-image-id') === details.id) {
      oldImage.alt = details.alt;
      return oldImage;
    }
    const image = document.createElement('img');
    image.className = 'ProductItem__Image Image--lazyLoad Image--fadeIn' + (alternate ? ' ProductItem__Image--alternate' : '');
    image.setAttribute('data-src', details.template);
    image.setAttribute('data-widths', JSON.stringify(details.widths));
    image.setAttribute('data-sizes', 'auto');
    image.setAttribute('data-image-id', details.id);
    image.setAttribute('data-media-id', details.mediaId || details.id);
    image.width = details.width;
    image.height = details.height;
    image.alt = details.alt;
    image.src = details.url;
    if (oldImage) oldImage.replaceWith(image);
    return image;
  }

  function apply(card, variant) {
    const config = configuration(card);
    card.querySelectorAll('.ProductItem__ImageWrapper, .ProductItem__Title > a, .ProductItem__ViewButton').forEach(link => {
      link.setAttribute('href', variant.url);
    });
    card.querySelectorAll('.ColorSwatch__Radio').forEach(input => {
      const selected = colorKey(input.value) === colorKey(variant.color);
      input.checked = selected;
      if (selected) {
        input.setAttribute('data-variant-url', variant.url);
        if (variant.image) {
          input.setAttribute('data-image-id', variant.image.id);
          input.setAttribute('data-image-url', variant.image.template);
          input.setAttribute('data-image-widths', JSON.stringify(variant.image.widths));
          input.setAttribute('data-image-aspect-ratio', variant.image.ratio);
        }
      }
    });
    const wrapper = card.querySelector('.ProductItem__ImageWrapper');
    const original = wrapper?.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    if (original && variant.image) {
      const image = updateImage(original, variant.image, false);
      const aspect = image.parentElement;
      aspect.style.setProperty('--aspect-ratio', variant.image.ratio);
      if (config.natural) aspect.style.paddingBottom = 100 / variant.image.ratio + '%';
      if (!config.horizontal) aspect.style.maxWidth = variant.image.width + 'px';
      const alternate = aspect.querySelector('.ProductItem__Image--alternate');
      if (config.secondary && variant.alternate) {
        const secondary = updateImage(alternate, variant.alternate, true);
        if (!secondary.parentElement) aspect.insertBefore(secondary, image);
        wrapper.classList.add('ProductItem__ImageWrapper--withAlternateImage');
        window.lazySizes?.loader?.unveil(secondary);
      } else {
        alternate?.remove();
        wrapper.classList.remove('ProductItem__ImageWrapper--withAlternateImage');
      }
      window.lazySizes?.loader?.unveil(image);
    } else {
      wrapper?.classList.remove('ProductItem__ImageWrapper--withAlternateImage');
    }
    card.setAttribute('data-swiss-selected-color', variant.color);
    remember(config.productId, variant.color);
  }

  function refresh() {
    scheduled = false;
    const lists = new Map();
    document.querySelectorAll(selector).forEach(card => {
      if (!configuration(card)) return;
      const list = card.closest('.ProductList') || card.closest('[data-section-id]') || card.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push(card);
    });
    lists.forEach((cards, list) => {
      const old = listStates.get(list);
      if (old && old.length === cards.length && old.every((card, index) => card === cards[index])) return;
      listStates.set(list, cards);
      const history = [];
      for (let offset = 0; offset < cards.length; offset += 6) {
        const block = cards.slice(offset, offset + 6);
        const selections = allocate(block, history);
        selections.forEach(selection => apply(selection.card, selection.variant));
        block.forEach(card => {
          const color = card.getAttribute('data-swiss-selected-color');
          history.push(color ? colorKey(color) : null);
        });
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  window.SwissKopperColorMix = {refresh: schedule};
  document.addEventListener('change', event => {
    if (!event.target.matches('.ColorSwatch__Radio')) return;
    const card = event.target.closest(selector);
    if (!card) return;
    const config = configuration(card);
    const variant = config?.variants.find(item => colorKey(item.color) === colorKey(event.target.value));
    if (!variant) return;
    manualSelections.set(card, variant);
    apply(card, variant);
  }, true);

  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
